module.exports = __webpack_public_path__ + "static/media/Sol-Ark.7e4bacbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sol-Ark.jpg
// module id = 1099
// module chunks = 0